// @flow
import * as React from 'react';
import {Component} from 'react';
import PropTypes from 'prop-types';

import ExperimentContext from './ExperimentContext';

import type {AbacusEvaluatedTests} from '../../types';

type Props = {abacus: AbacusEvaluatedTests, children?: React.Node};
type State = {abacus: AbacusEvaluatedTests};

class ExperimentProvider extends Component<Props, State> {
    static propTypes = {
        // c.f. AbacusEvaluatedTests type
        /** Map of evaluated experiments. */
        abacus: PropTypes.objectOf(
            PropTypes.shape({
                bucket: PropTypes.shape({bucketConfig: PropTypes.string}),
                experimentKey: PropTypes.shape({
                    experimentId: PropTypes.number,
                    experimentName: PropTypes.string.isRequired
                }).isRequired,
                value: PropTypes.number.isRequired
            })
        ).isRequired
    };

    constructor(props: Props) {
        super(props);
        const {abacus} = this.props;
        this.state = {
            abacus
        };
    }
    render() {
        return (
            <ExperimentContext.Provider value={this.state.abacus}>
                {this.props.children}
            </ExperimentContext.Provider>
        );
    }
}

export default ExperimentProvider;
